import { v2Request } from "../helpers/request";

export interface CalendarPanelDataFilters {
  type?: string;
  repName?: string;
  status?: "booked" | "unbooked" | "all";
}

export interface CalendarPanelDataSort {
  by?: "date" | "type" | "confirmation";
  order?: "asc" | "desc";
}

export interface CalendarPanelDataPagination {
  page?: number;
  limit?: number;
}

export interface CalendarPanelDataParams {
  apptIds: number[];
  filters?: CalendarPanelDataFilters;
  sort?: CalendarPanelDataSort;
  pagination?: CalendarPanelDataPagination;
}

export interface AdvanceCalendarFiltersParams {
  from: string; // YYYY-MM-DD
  to: string; // YYYY-MM-DD
  filters?: {
    type?: string;
    repName?: string;
    bookingStatus?: "booked" | "unbooked" | "all";
    confirmation?: "confirmed" | "unconfirmed" | "all";
  };
  sort?: {
    by?: "date" | "type" | "confirmation";
    order?: "asc" | "desc";
  };
  pagination?: {
    page?: number;
    limit?: number;
  };
}

export const getOfficeCalendarData = (from: string, to: string) => {
  return v2Request(`/appointments/calendar-data/${from}/${to}`);
};

export const getCalendarPanelData = (params: CalendarPanelDataParams) => {
  return v2Request(`/appointments/calendar-panel-data`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const searchOfficeReps = (searchQuery: string) => {
  return v2Request(
    `/users/reps-search?search=${encodeURIComponent(searchQuery)}`,
  );
};

export const getOfficeRepDetails = (repId: number) => {
  return v2Request(`/users/rep-details/${repId}`);
};

export const getAdvanceCalendarFilters = (
  params: AdvanceCalendarFiltersParams,
) => {
  return v2Request(`/appointments/advance-filters`, {
    method: "POST",
    body: JSON.stringify(params),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
